<template>
  <div class="act270_container">
    <div class="act270_container-item">
      <img :src="$cdnPath.img + 'Activity/270/bg2@2x.png'"/>
      <div class="act270_container-tast-b btn1" @click="goBtn('sign')">
        <img :src="getBtn(ling.sign)"/>
      </div>
      <div class="act270_container-tast-b btn2" @click="goBtn('browse')">
        <img :src="getBtn(ling.browse)"/>
      </div>
      <div class="act270_container-tast-b btn3" @click="goBtn('read_10')">
        <img :src="getBtn(ling.read_10)"/>
      </div>
      <div class="act270_container-tast-b btn4" @click="goBtn('read_30')">
        <img :src="getBtn(ling.read_30)"/>
      </div>
      <div class="act270_container-xiaoshu">
        <img :src="$cdnPath.img + 'Activity/270/btn_3@2x.png'" @click="goBrowse"/>
      </div>
    </div>
    <div class="act270_container-item">
      <div class="act270_container-zp-zhuan" @click="chou"></div>
      <div class="act270_container-zp-record" @click="histListFlag = true"></div>
      <img :src="$cdnPath.img + 'Activity/270/bg3@2x.jpg'"/>
      <div class="act270_container-zp-pan" :style="{transform: 'rotate(' + rotate + 'deg)'}">
        <img :src="$cdnPath.img + 'Activity/270/pan@2x.png'"/>
      </div>
      <div class="act270_container-zp-mask">
        <img :src="$cdnPath.img + 'Activity/270/mask@2x.png'"/>
      </div>
      <div class="act270_container-zp-zz">
        <img :src="$cdnPath.img + 'Activity/270/zz@2x.png'"/>
      </div>
      <div class="act270_container-times">
        <img :src="$cdnPath.img + 'Activity/270/icon@2x.png'" style="height: 100%; width: auto; padding: 0 .1rem;"/>× {{chouNums}}
      </div>
      <div class="act270_container-notice">
        <yd-rollnotice autoplay="2000">
          <yd-rollnotice-item v-for="win in win_show">{{win.user}} 刚刚抽中了 {{gift[win.gift].txt}}</yd-rollnotice-item>
        </yd-rollnotice>
      </div>
    </div>
    <yd-popup v-model="show1" position="center" width="90%">
      <div class="pop-box">
        <div class="pop-box-img" v-if="popType < 2">
          <img :src="popImg"/>
          <div>{{popMsg}}</div>
        </div>
        <div class="pop-box-info" v-else>
          <h3>真的要放弃特权嘛？</h3>
          <p>（放弃就没有了哦）</p>
        </div>
        <div class="pop-box-btn" v-if="popType < 2">
          <div class="pop-box-btn-item" @click="doPay" v-if="popType == 1"><div>马上享用</div></div>
          <div class="pop-box-btn-item" @click="show1 = false" v-else><div>{{popBtn}}</div></div>
        </div>
        <div class="pop-box-btn" v-else>
          <div class="pop-box-btn-item" @click="popType = 1">享用特权</div>
          <div class="pop-box-btn-item" @click="show1 = false"><div>确定放弃</div></div>
        </div>
        <div v-show="popType == 1" @click="popType = 2" style="color:#685B79; text-align: center;margin-bottom: .2rem;">放弃特权</div>
      </div>
    </yd-popup>
    <yd-popup v-model="histListFlag" position="left" width="80%" style="line-height: 1.2em;">
      <yd-timeline>
        <yd-timeline-item v-for="his in user_win">
          <p>抽中 <span style="font-weight: bold;">【{{gift[his.gift].txt}}】</span></p>
          <p style="margin-top: 10px; font-size: .8em;">{{his.time}}</p>
        </yd-timeline-item>
      </yd-timeline>
    </yd-popup>
  </div>
</template>

<script>
import { post, fetch } from '../../../../../api/appRequest'
import API from '@/api/app.conf.js'

export default {
  name: "index",
  data() {
    return {
      show1: false,
      histListFlag: false,
      rotate: 0,
      fooId: 11010,
      activityId: 270,
      ling: {
        browse: 0,
        read_10: 0,
        read_30: 0,
        sign: 1
      },
      gift: {
        1: { txt: '50金币', min: 150, max: 210, icon: 'gold', btn: '妥妥的~'},
        2: { txt: '年VIP 7折特权卡', min: 30, max: 90, icon: 'vip_y', btn: '2'},
        3: { txt: '100金币', min: 270, max: 330, icon: 'gold', btn: '厉害了~'},
        4: { txt: '300金币', min: 90, max: 150, icon: 'gold', btn: '哇塞~'},
        5: { txt: '1天VIP', min: 210, max: 270, icon: 'vip_d', btn: '太棒了！'},
        6: { txt: '月VIP', min: -30, max: 30, icon: 'vip_m', btn: '@天了噜@'}
      },
      chouIng: false,
      chouNums: 0,
      popImg: '',
      popMsg: '',
      popBtn: '',
      popType: 0,
      user_win: [],
      win_show: []
    };
  },
  mounted(){
    this.$dialog.loading.open('正在初始化...');
    fetch(API.U('xs_info')).then(res => {
      this.$dialog.loading.close();
      if (res.status_code == 200) {
        const data = JSON.parse(decodeURIComponent(res.data))
        this.ling = data
      } else if (res.status_code == 403) {
        this.$dialog.alert({
          mes: "请先登录", callback: () => {
            this.$yymd.yy2c('{"a":12,"v":1,"p":{}}', 0)
          }
        });
      } else {
        this.$dialog.alert({mes:'code:' + res.status_code + '错误' + res.message});
      }
    }).catch(e => {
      this.$dialog.loading.close();
    })
    fetch(API.U('luck_draw_num')).then(res => {
      if (res.status_code == 200) {
        this.chouNums = res.data
      }
    })
    fetch(API.U('luck_draw_data')).then(res => {
      if (res.status_code == 200) {
        const data = JSON.parse(decodeURIComponent(res.data))
        this.user_win = data.user_win
        this.win_show = data.win_show
      }
    })
  },
  methods:{
    doPay () {
      this.$emit('pay', {goodsId : 285, title:'年VIP',content:'#7折超值特权#',price:'69', spm:'.285', callback: res => {
        if (res == 'success') {
          this.show1 = false
        }
        }})
    },
    showMsg (msg, icon, btn = '知道了') {
      this.popImg = this.$cdnPath.img + 'Activity/270/'+icon+'@2x.png'
      this.popMsg = msg
      this.popBtn = btn
      this.popType = btn == '2' ? 1 : 0
      this.show1 = true
    },
    chou() {
      if (this.chouIng) {
        return
      }
      if (this.chouNums <= 0) {
        this.showMsg('抽奖需要有影币哦，去完成上方任务获得吧！', 'nono')
        return
      }
      this.chouIng = true
      // // const gift = this.gift[Math.round(Math.random() * 6)]
      // const gift = this.gift[2]
      // const rotate = gift.min + 8 + Math.round(Math.random() * 52)
      // this.rotate = (Math.round(this.rotate / 360) * 360) +  360*8 + rotate
      // setTimeout(() => {
      //   this.chouIng = false
      //   this.showMsg('恭喜你抽中' + gift.txt, gift.icon, gift.btn)
      // }, 4000)
      //
      // // this.chouNums--
      // return ;
      this.$dialog.loading.open('正在抽奖...');
      fetch(API.U('luck_draw')).then(res => {
        if (res.status_code == 200) {
          this.$dialog.loading.close()
          const gift = this.gift[res.data]
          const rotate = gift.min + 8 + Math.round(Math.random() * 52)
          this.rotate = (Math.round(this.rotate / 360) * 360) +  360*8 + rotate
          this.chouNums--
          setTimeout(() => {
            this.chouIng = false
            this.showMsg('恭喜你抽中' + gift.txt, gift.icon, gift.btn)
          }, 4000)
        }
      }).catch(e => {
        this.$dialog.loading.close()
      })
      this.rotate += 360*8;
    },
    getBtn (s) {
      return this.$cdnPath.img + 'Activity/270/btn_' + (s == 0 ? '2': (s == 1 ? '1' : '4'))+'@2x.png';
    },
    doLing (action) {
      const conf = {
        complete_browse: 'xs_complete_browse',
        browse: 'xs_browse',
        read_10: 'xs_read1',
        read_30: 'xs_read2',
        sign: 'xs_sign'
      }
      this.$dialog.loading.open('正在领取...');
      fetch(API.U(conf[action])).then(res => {
        this.$dialog.loading.close();
        if (res.status_code == 200) {
          if (action == 'complete_browse') {
            this.ling.browse = 1
          } else {
            this.ling[action] = 2
            this.chouNums++
            this.showMsg('恭喜完成任务 +1 有影币', 'bi')
          }
        }
      }).catch(e => {
        this.$dialog.loading.close()
      })
    },
    goBtn (action) {
      if (this.ling[action] == 2) {
        return
      } else if (this.ling[action] == 1) {
        this.doLing(action)
      } else {
        if (action == 'read_10') {
          this.$dialog.alert({ mes: '在线阅读10分钟图解才能领取哦，快去阅读吧~' })
        } else if (action == 'read_30') {
          this.$dialog.alert({ mes: '在线阅读30分钟图解才能领取哦，快去阅读吧~' })
        } else if (action == 'browse') {
          this.doLing('complete_browse')
          this.goBrowse()
        }
      }
    },
    goBrowse () {
      this.$yymd.yy2c('{"a":100,"v":1,"p":{"url":"https://apph5.yymedias.com/terror","type":"1"}}')
    }

  }
}
</script>

<style rel="stylesheet/less" lang="less" scoped>
  .act270_container {
    position: relative;
    &-item {
      position: relative;
    }
    img {
      width:100%;height:auto;
    }
    &-xiaoshu {
      position:absolute;
      width:38%; height:11.63%; top:67.17%; left:31%;
    }
    &-tast-b {
      position:absolute;
      width:17.87%; height:6.96%; left:67.6%;
      &.btn1 {
        top:27.17%;
      }
      &.btn2 {
        top:37.28%;
      }
      &.btn3 {
        top:47.28%;
      }
      &.btn4 {
        top:57.28%;
      }
    }

    &-notice {
      position: absolute;
      top:14.3%; left:26%; width:70%; height: auto;
      color: #fff;
      .yd-rollnotice {
        background-color:transparent;
      }
    }

    &-zp-mask {
      position: absolute;
      width:80.53%; height:32.98%; top:42.81%; left:9.73%;
    }
    &-zp-pan {
      position: absolute;
      width:65.07%; height:42.81%; top:28.07%; left:17.47%;
      transition: all 4s cubic-bezier(0,1,0,1);
    }
    &-zp-zz {
      position: absolute;
      width:12.8%; height:8.25%; top:23.16%; left:43.6%;
    }
    &-times {
      position: absolute;height:4.04%; top:94.56%;width:50%;left:25%; text-align: center;
      font-size: .4rem; font-weight: bold;
      color:#fff; display:flex;
      justify-content:center; //内容水平居中
      align-items:center; //内容垂直居中
    }
    &-zp-zhuan {
      position: absolute;
      /*border:1px solid #fff; */
      z-index: 5;
      top:40%; left:20%; width:60%; height:52%;
    }
    &-zp-record {
      position: absolute;
      /*border:1px solid #fff; */
      z-index: 5;
      top:22%; left:74%; width:26%; height:11%;
    }
  }
  .pop-box {
    background-color:#0D0A11;
    border:.1rem solid #69606E;
    padding:.2rem;
    border-radius: .2rem;
    line-height: 1.5em;
    font-size:.32rem;
    color:#fff;

    &-info {
      height: 3rem; text-align: center;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      h3 {
        margin-top: 1rem;
        font-size:.4rem;
        line-height: 1.5em;
        font-weight: normal;
      }
      p {
        color:#685B79;
      }
    }
    &-img {
      text-align: center;
      /*border:1px solid #fff;*/
      img {
        height: 3rem;
        width: auto;
      }
      div {
        margin-top: -.3rem;
        /*border:1px solid #fff;*/
      }
    }
    &-btn {
      display: flex;
      width:80%;margin-left:10%;
      &-item {
        margin: .3rem 0;
        line-height: .8rem;
        text-align: center;
        flex: 1; width:50%;
        div {
          width:100%;
          background: linear-gradient(#f04949 0%, #ff5f5f 100%);
          border-radius: 2rem;
        }
      }
    }
  }
</style>